import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { inSessionProperties } from '../../canvas/EditorSession';
import { StateProperty } from '../../canvas/ExtendableStore';
import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTools } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { ActiveSketchInfo as ActiveSketchInfoRef } from './ActiveSketchInfo';
import { eraserTool } from './EraserTool';
import { clearMarkings, sketchMerge } from './MarkerCommands';
import { MarkerMechanics } from './MarkerMechanics';
import { markerTool } from './MarkerTool';
import { markerToolboxItem } from './MarkerToolboxItem';

export class MarkerPackage implements Package {

    public install = (host: PackageHost) => host
        .register(MarkerMechanics, 'singleton', 'startable')
        .plug(inCommands(clearMarkings, sketchMerge))
        .plug(inTools(markerTool, eraserTool))
        .plug(inToolboxItems(markerToolboxItem))
        .plug(inSessionProperties(StateProperty.variable(ActiveSketchInfoRef, ActiveSketchInfoRef.empty)))
        ;
}
